import { Component, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { UpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.template';
import { IPointOfSale } from 'src/app/pages/gestion/point-of-sale/point-of-sale.interface';
import { SaleNoteCancelDocumentService } from '../../sales-notes-cancel.service';

@Component({
  selector: 'pg-cancel-sale-note-dialog',
  templateUrl: './cancel-sale-note.component.html',
  providers: [MessageService]
})
export class CancelSaleNoteComponent extends UpdateTemplate {
  @Input() idToCancel: number;
  select = {
    pointOfSale: {
      openDialog: false,
      type: 'single',
      id: null,
      selected: false
    }
  };

  constructor(
    private fb: FormBuilder,
    private serviceBase: SaleNoteCancelDocumentService,
    private messageService: MessageService
  ) {
    super('Anulando nota de venta', serviceBase);
  }

  ngOnInit() {
    this.fg = this.fb.group({
      pointOfSale: [null, [Validators.required]]
    });
  }

  onSelectedPointOfSale(pointOfSale: any) {
    if (pointOfSale) {
      this.fg
        .get('pointOfSale')
        .setValue(pointOfSale.branchStoreName + ' - ' + pointOfSale.code);
      this.select.pointOfSale.id = pointOfSale.id;
      this.select.pointOfSale.selected = true;
    }
    this.select.pointOfSale.openDialog = false;
  }

  async onSubmit() {
    // console.log('updating cancelation..');
    await this.updateItem$({
      pointOfSaleId: this.select.pointOfSale.id
    });
  }
}
